const STORAGE_KEY = 'visitedLessons'
const LIMIT = 2
// TODO: retrieve limit from Builder config
export const trackLessonVisit = (lessonId) => {
    const raw = localStorage.getItem(STORAGE_KEY)
    const visited = raw ? JSON.parse(raw) : []

    // If already visited (by lessonId), do nothing
    const alreadyVisited = visited.some((entry) => entry.lessonId === lessonId)
    if (alreadyVisited) return visited

    // If limit reached, do not add more
    if (visited.length >= LIMIT) return visited

    const timeVisited = new Date().toISOString()
    const updated = [...visited, {lessonId, timeVisited}]
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
    return updated
}

export const getVisitedLessons = () => {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
}

export const isVisited = (lessonId) => {
    const visited = getVisitedLessons()
    return visited.some((entry) => entry.lessonId === lessonId)
}

export const canVisitLesson = (lessonId) => {
    const visited = getVisitedLessons()
    return visited.some((entry) => entry.lessonId === lessonId) || visited.length < LIMIT
}

export const clearVisitedLessons = () => {
    localStorage.removeItem('visitedLessons')
}
